<template>
    <div class="nav-bg container-fluid">
      <div class="container">
        <b-navbar class="navigation" type="dark" toggleable="md">
          <b-navbar-brand to="/">
            <img src="../assets/2026/R2_s2026_Logo_Color_Dates_WebRes_Medium.png" style="width: 190px; height: 45px;" class="logo"
              alt="Siggraph 2026 Student Volunteer Program Logo">
            <br />
            <div style="color: #2A4249; font-size: 13px; margin-top: 2px; font-weight: 600">STUDENT VOLUNTEER PORTAL
            </div>
          </b-navbar-brand>

          <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

          <b-collapse is-nav id="nav_collapse">
            <!-- Right aligned nav items -->
            <b-navbar-nav v-if="isAuthenticated" class="ml-auto text-right">
              <b-nav-item to="/dashboard">
                <div>Dashboard</div>
              </b-nav-item>
              <b-nav-item v-if="isTeamLeader && isBeforeJuryDeadline && isAfterDeadline && isAfterJuryReleased" to="/jury/view">
                <div>Jury</div>
              </b-nav-item>
              <b-nav-item v-if="isTeamLeader && isAfterSchedulesOut" to="/schedule/tl">
                <div>Schedule</div>
              </b-nav-item>
              <b-nav-item v-else-if="statusId === 2 && isAfterSchedulesOut" to="/schedule/sv">
                <div>Schedule</div>
              </b-nav-item>
              <!-- <b-nav-item to="/support">Support</b-nav-item> -->
              <b-nav-item to="/profile">
                <div>Profile</div>
              </b-nav-item>
              <b-nav-item href="#" @click="logout">
                <div>Logout</div>
              </b-nav-item>
            </b-navbar-nav>
            <!-- <b-navbar-nav v-else class="ml-auto text-right">
          <b-nav-item href="#eligibility"><div>Eligibility</div></b-nav-item>
          <b-nav-item href="#expectations"><div>Expectations</div></b-nav-item>
          <b-nav-item href="#benefits"><div>Benefits</div></b-nav-item>
          <b-nav-item href="#deadlines"><div>Deadlines</div></b-nav-item>
        </b-navbar-nav> -->
          </b-collapse>
        </b-navbar>
      </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'Navigation',
  data () {
    return {}
  },
  methods: {
    logout (e) {
      e.preventDefault()
      this.$store.dispatch('user/logout')
    }
  },
  computed: {
    ...mapState('user', ['isTeamLeader', 'isAuthenticated']),
    ...mapState('application', ['statusId']),
    ...mapGetters(['isAfterSchedulesOut', 'isAfterDeadline', 'isAfterJuryReleased']),
    isBeforeAcceptances: function () {
      return moment().isBefore(this.$store.state.acceptanceDate)
    },
    isBeforeJuryDeadline: function () {
      return moment().tz('UTC').isBefore(this.$store.state.juryDeadline)
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/Navigation.scss";
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue